/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} System_AccessInputs */

const en_system_access = /** @type {(inputs: System_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System Access`)
};

const es_system_access = /** @type {(inputs: System_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso al Sistema`)
};

const fr_system_access = /** @type {(inputs: System_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès système`)
};

const de_system_access = /** @type {(inputs: System_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systemzugang`)
};

const id_system_access = /** @type {(inputs: System_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Sistem`)
};

/** @type {(inputs: System_AccessInputs) => LocalizedString} */
const ja_system_access = en_system_access;

/** @type {(inputs: System_AccessInputs) => LocalizedString} */
const zh_system_access = en_system_access;

/** @type {(inputs: System_AccessInputs) => LocalizedString} */
const ar_system_access = en_system_access;

/** @type {(inputs: System_AccessInputs) => LocalizedString} */
const it_system_access = en_system_access;

/** @type {(inputs: System_AccessInputs) => LocalizedString} */
const ru_system_access = en_system_access;

/** @type {(inputs: System_AccessInputs) => LocalizedString} */
const pt_system_access = en_system_access;

/** @type {(inputs: System_AccessInputs) => LocalizedString} */
const ko_system_access = en_system_access;

/**
* | output |
* | --- |
* | "System Access" |
*
* @param {System_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const system_access = /** @type {((inputs?: System_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<System_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_system_access(inputs)
	if (locale === "es") return es_system_access(inputs)
	if (locale === "fr") return fr_system_access(inputs)
	if (locale === "de") return de_system_access(inputs)
	if (locale === "ja") return ja_system_access(inputs)
	if (locale === "zh") return zh_system_access(inputs)
	if (locale === "ar") return ar_system_access(inputs)
	if (locale === "id") return id_system_access(inputs)
	if (locale === "it") return it_system_access(inputs)
	if (locale === "ru") return ru_system_access(inputs)
	if (locale === "pt") return pt_system_access(inputs)
	return ko_system_access(inputs)
});